/**
 * ViewToggle — Grid/List view switch for product listings
 *
 * Two icon buttons side-by-side: grid_view and view_list.
 * Active state uses electric-blue background with white text.
 * Follows Sandvik brand: rounded-none on all buttons.
 */

export default function ViewToggle({ viewMode = 'list', onChange }) {
  const modes = [
    { value: 'grid', icon: 'grid_view', label: 'Grid view' },
    { value: 'list', icon: 'view_list', label: 'List view' },
  ];

  return (
    <div className="inline-flex" role="radiogroup" aria-label="View mode">
      {modes.map(({ value, icon, label }) => {
        const isActive = viewMode === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={isActive}
            aria-label={label}
            title={label}
            onClick={() => onChange?.(value)}
            className={`
              inline-flex items-center justify-center w-10 h-10 rounded-none
              border border-n2 transition-colors duration-150
              ${isActive
                ? 'bg-electric-blue text-white border-electric-blue'
                : 'bg-n1 text-n5 hover:text-carbon-black hover:bg-n2'
              }
              ${value === 'grid' ? 'border-r-0' : ''}
            `}
          >
            <span className="material-symbols-outlined text-xl">{icon}</span>
          </button>
        );
      })}
    </div>
  );
}
